export const LOGIN_DETAILS_REDUCER = "loginDetails";
export const KANBAN_BOARD_REDUCER = "kanbanBoardDetails";
